const DateService = {
  getToday: () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  },

  getDaysFromToday: days => {
    const date = DateService.getToday();
    date.setDate(date.getDate() + days);
    return date;
  },

  isWeekday: date => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  },

  toLocalDate: value => {
    const d = new Date(value);
    d.setHours(0, 0, 0, 0);
    return d;
  },

  isWithinDaysFromToday: (date, days) => {
    const target = new Date(date);
    target.setHours(0, 0, 0, 0);
    return target <= DateService.getDaysFromToday(days);
  },

  getNextBookableDays: calendarDays => {
    const result = [];
    const start = DateService.getToday();
    for (let i = 0; i <= calendarDays; i++) {
      const date = new Date(start);
      date.setDate(start.getDate() + i);
      if (DateService.isWeekday(date)) {
        result.push(date);
      }
    }
    return result;
  },

  // Get last day of the month after next by subtracting 1 day
  getEndOfFirstBillingPeriod: startDate => {
    const firstOfMonthAfterNext = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 2,
      1
    );
    return new Date(firstOfMonthAfterNext - 1);
  },

  formatDate: date => {
    const d = new Date(date);
    const pad = (n, len = 2) => String(Math.abs(n)).padStart(len, '0');
    const offsetMinutes = -d.getTimezoneOffset();
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const offset = `${sign}${pad((offsetMinutes / 60) | 0)}:${pad(offsetMinutes % 60)}`;

    console.log(
      `Formatted date: ${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T00:00:00${offset}`
    );

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T00:00:00${offset}`;
  },

  toUtcMidnightIso: date => {
    const d = new Date(date);
    return new Date(
      Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())
    ).toISOString();
  },
};

export default DateService;
